import * as React from 'react';
import {useIntl} from '@sail/intl';
import {LocaleGate} from 'mkt-ssr/components/LocaleGate/LocaleGate';
import {SiteFooterListItem} from 'mkt-ssr/components/sail/SiteFooterSection/SiteFooterListItem';
import {
  legalNotice,
  privacyChoicesLabel,
} from 'mkt-ssr/components/sail/SiteFooterSection/SiteFooter.messages';
import {useLinkResolver} from 'mkt-ssr/lib/routing/LinkResolver';

/**
 * Renders legal notices with its localization overrides
 */
export const SiteFooterLegalNotice = () => {
  const {formatMessage} = useIntl();

  const {createRoute} = useLinkResolver();

  return (
    <>
      <LocaleGate countries="US">
        <SiteFooterListItem
          label={formatMessage(privacyChoicesLabel)}
          href={createRoute('https://privacy.stripe.com/')}
          data-analytics-label="CPRA privacy settings"
        />
      </LocaleGate>
      <LocaleGate countries="FR">
        <SiteFooterListItem
          label={formatMessage(legalNotice)}
          href={createRoute('https://stripe.com/legal/france-legal-notice')}
          data-analytics-label="France legal notice"
        />
      </LocaleGate>
      <LocaleGate countries="DE">
        <SiteFooterListItem
          label="Impressum"
          href={createRoute('https://stripe.com/legal/imprint')}
          data-analytics-label="German legal Imprint"
        />
      </LocaleGate>
    </>
  );
};
